var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExperienceManagerActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7V0H20V7H9ZM0 16V9H10V16H0ZM0 7V0H7V7H0ZM15 18L14.7 16.5C14.5 16.4167 14.3125 16.3292 14.1375 16.2375C13.9625 16.1458 13.7833 16.0333 13.6 15.9L12.15 16.35L11.15 14.65L12.3 13.65C12.2667 13.4333 12.25 13.2167 12.25 13C12.25 12.7833 12.2667 12.5667 12.3 12.35L11.15 11.35L12.15 9.65L13.6 10.1C13.7833 9.96667 13.9625 9.85417 14.1375 9.7625C14.3125 9.67083 14.5 9.58333 14.7 9.5L15 8H17L17.3 9.5C17.5 9.58333 17.6875 9.67083 17.8625 9.7625C18.0375 9.85417 18.2167 9.96667 18.4 10.1L19.85 9.65L20.85 11.35L19.7 12.35C19.7333 12.5667 19.75 12.7833 19.75 13C19.75 13.2167 19.7333 13.4333 19.7 13.65L20.85 14.65L19.85 16.35L18.4 15.9C18.2167 16.0333 18.0375 16.1458 17.8625 16.2375C17.6875 16.3292 17.5 16.4167 17.3 16.5L17 18H15ZM17.4125 14.4125C17.8042 14.0208 18 13.55 18 13C18 12.45 17.8042 11.9792 17.4125 11.5875C17.0208 11.1958 16.55 11 16 11C15.45 11 14.9792 11.1958 14.5875 11.5875C14.1958 11.9792 14 12.45 14 13C14 13.55 14.1958 14.0208 14.5875 14.4125C14.9792 14.8042 15.45 15 16 15C16.55 15 17.0208 14.8042 17.4125 14.4125Z",
    fill: "#5F11EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExperienceManagerActive);
export default __webpack_public_path__ + "static/media/icon-experience-manager-active.fc0f06554b443ca695487a70d7ac8562.svg";
export { ForwardRef as ReactComponent };